/**
 * CHIKAS · Ver más / Ver menos en Featured collection (grid, sin slider)
 */
(() => {
  const SEL = '[data-chikas-expand]';

  function sync(root) {
    const initial = Number(root.dataset.initial || 8);
    const step = Number(root.dataset.step || 16);
    let shown = Number(root.dataset.shown || initial);
    const cards = [...root.querySelectorAll('[data-chikas-expand-item]')];
    const total = cards.length;
    shown = Math.min(Math.max(shown, initial), total);

    cards.forEach((card, i) => {
      card.hidden = i >= shown;
      card.classList.toggle('chikas-expand-hidden', i >= shown);
    });

    root.dataset.shown = String(shown);

    const moreBtn = root.querySelector('[data-chikas-expand-more]');
    const lessBtn = root.querySelector('[data-chikas-expand-less]');
    const hint = root.querySelector('[data-chikas-expand-hint]');
    const wrap = root.querySelector('[data-chikas-expand-controls]');
    const left = Math.max(0, total - shown);
    const canMore = left > 0;
    const canLess = shown > initial;

    if (wrap) wrap.hidden = !canMore && !canLess;
    if (moreBtn) moreBtn.hidden = !canMore;
    if (lessBtn) lessBtn.hidden = !canLess;
    if (hint) {
      if (canMore) hint.textContent = `${left} referencias más en esta selección`;
      else if (canLess) hint.textContent = 'Mostrando la selección ampliada';
      else hint.textContent = '';
    }
  }

  function onClick(e) {
    const more = e.target.closest('[data-chikas-expand-more]');
    const less = e.target.closest('[data-chikas-expand-less]');
    if (!more && !less) return;

    const root = (more || less).closest(SEL);
    if (!root) return;

    const initial = Number(root.dataset.initial || 8);
    const step = Number(root.dataset.step || 16);
    const total = root.querySelectorAll('[data-chikas-expand-item]').length;
    let shown = Number(root.dataset.shown || initial);

    if (more) shown = Math.min(total, shown + step);
    if (less) {
      shown = initial;
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.dataset.shown = String(shown);
    sync(root);
  }

  function init(root) {
    if (!root || root.dataset.chikasExpandReady) return;
    root.dataset.chikasExpandReady = '1';
    const initial = Number(root.dataset.initial || 8);
    root.dataset.shown = String(initial);
    sync(root);
  }

  function boot() {
    document.querySelectorAll(SEL).forEach(init);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.(SEL)?.forEach(init);
    if (e.target.matches?.(SEL)) init(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
